/* eslint-disable max-len */
export const emailRegEx = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
export const cellPhoneRegEx = /^(\([0-9]{2}\))\s([9]{1})?([0-9]{4})-([0-9]{4})$/
